import { Injectable } from '@angular/core';
import { IApplicationState } from '../../redux/state/application.state';
import { DocumentData, DocumentInfo } from '@formbird/types';
import { cloneDeep } from 'lodash';
import { AppStore } from '../../redux/store/app.store';

@Injectable({
  providedIn: 'root'
})
export class CurrentDocumentInfoService {

  constructor(
    private appStore: AppStore<IApplicationState>
  ) {
  }

  getDocumentInfo(): DocumentInfo {
    return this.appStore.getState().formState.documentInfo;
  }

  getDocumentData(unsavedDocumentListId): DocumentData {
    if (!unsavedDocumentListId) {
      return null;
    }

    const documentInfo = this.getDocumentInfo()[unsavedDocumentListId];
    if (!documentInfo) {
      this.getDocumentInfo()[unsavedDocumentListId] = {};
    }
    const documentData: DocumentData = <DocumentData> { ...documentInfo };
    documentData.document = cloneDeep(this.appStore.getState().formState.documents[documentInfo.documentId]);
    documentData.template = cloneDeep(this.appStore.getState().formState.documents[documentInfo.templateId]);

    return documentData;
  }

  getMainUnsavedDocumentListId(): string {
    const documentInfo = this.appStore.getState().formState.documentInfo;
    const unsavedDocumentListIds = Object.keys(documentInfo);
    return unsavedDocumentListIds.filter((unsavedDocumentListId: string) => {
      return documentInfo && documentInfo[unsavedDocumentListId] && documentInfo[unsavedDocumentListId].isMainDoc;
    })[0];
  }

  getMainDocumentData(): DocumentData {

    const mainUnsavedDocumentListId = this.getMainUnsavedDocumentListId();
    return this.getDocumentData(mainUnsavedDocumentListId);
  }

}
